import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { Map } from "immutable";
import { FormSection } from "redux-form";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import { withRma } from "MODULES/RMAsAndWarranties/decorators";
import ShippingSection from "MODULES/shared/components/ShippingSection";
import {
  COMPANY,
  DROPSHIP
} from "MODULES/shared/components/ShippingSection/shippingTypes";
import * as actions from "MODULES/RMAsAndWarranties/actions";
import Errors from "MODULES/shared/components/Forms/Errors";
import { SUCCESS } from "LIB/submission";
import validate from "../ShippingSection/validate";

function CustomButton({
  disabled,
  submitting,
  handleSubmit,
  onSubmit,
  close,
  copyToRepair
}) {
  const saveText = copyToRepair ? "Save And Update RO" : "Save";
  return (
    <button
      disabled={disabled || submitting}
      type="submit"
      className="btn btn-primary"
      onClick={handleSubmit(values => {
        onSubmit({
          ...values,
          copy_address_to_repair: copyToRepair
        }).then(() => {
          close();
          return SUCCESS;
        });
      })}
    >
      {submitting && <i className="fa fa-cog fa-spin fa-fw fa-lg" />}
      {submitting ? " Saving" : saveText}
    </button>
  );
}

CustomButton.propTypes = {
  disabled: T.bool.isRequired,
  submitting: T.bool.isRequired,
  handleSubmit: T.func,
  onSubmit: T.func,
  close: T.func,
  copyToRepair: T.bool
};

export function Form(props) {
  const { rma, close, submitFailed, errorMessages, editable } = props;
  const shipToOptions = [
    {
      text: "Company",
      value: COMPANY
    },
    {
      text: "Other",
      value: DROPSHIP
    }
  ];

  return (
    <AppForm {...props} handleSubmit={() => {}}>
      <AppForm.Body>
        <FormSection name="">
          <h4>Ship To</h4>
          <ShippingSection
            shipToOptions={shipToOptions}
            shippingType="ship_to"
            shipToCustomer={(rma.get("company") || Map()).toJS()}
            shipToCompany={rma.get("ship_to_company")}
          />
        </FormSection>
      </AppForm.Body>
      <AppForm.Footer>
        {submitFailed && <Errors errors={errorMessages} />}
        <AppForm.Cancel close={close} editable={editable} />
        {rma.getIn(["repair_order_line_item", "id"]) &&
          !rma.getIn(["repair_order_line_item", "received"]) && (
            <CustomButton {...props} copyToRepair />
          )}

        <CustomButton {...props} />
      </AppForm.Footer>
    </AppForm>
  );
}

Form.propTypes = {
  rma: T.instanceOf(Map)
};

export default connect(undefined, {
  onSubmit: actions.update
})(
  withRma(
    form({
      form: "rmaShipToDetails",
      validate
    })(Form)
  )
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/ShipTo/Form.jsx